import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const exportToPDF = ({ data, title, fileName, filters }) => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  const columns = Object.keys(data?.[0] ?? {});
  const rows = data?.map((row) => columns.map((col) => row[col])) ?? [];

  if (title) {
    doc.setTextColor(4, 51, 59);
    doc.setFontSize(16);
    doc.text(title, 14, 10, { maxWidth: 200 });
  }


  autoTable(doc, {
    head: [rows[0]],
    body: rows.slice(1),
    startY: 20,
    theme: "grid",
    styles: { fontSize: 8 },
    horizontalPageBreak: true,
    bodyStyles: {
      minCellWidth: 40,
      cellWidth: 'auto',
      lineColor: '#99A6B7',
      textColor: '#04333B'
    },
    margin: { top: 20 },
    didDrawPage: (data) => {
      doc.setTextColor(4, 51, 59);
      doc.setFontSize(8);
      doc.text(`Page ${doc.internal.getNumberOfPages()}`, 280, 200);
    },
    didParseCell: function (data) {
      if (data.section === "head") {
        data.cell.styles.textColor = '#99A6B7';
        data.cell.styles.fillColor = '#FFFFFF';
      }
    },
  });

  const finalY = doc.lastAutoTable.finalY || 10;

  doc.setTextColor(4, 51, 59);
  doc.setFontSize(12);
  const textLinesWrapped = doc.splitTextToSize(filters.join(', '), 280);

  doc.text(textLinesWrapped, 14, finalY + 10);
  doc.save(fileName ?? 'table.pdf');
};

export default exportToPDF;
